import { useSelector, useDispatch } from "react-redux"
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { obtenerPasajerosDocumentos } from "../../../../ducks/viajeCalendarioDuck";
import { useEffect } from "react";
import { FormatoFechaIso } from "./../../../../utils/FormatFecha"
const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

const TablaDocumentos = () => {
  const { pasajeros, cliente } = useSelector(store => store.calendario)
  const classes = useStyles()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(obtenerPasajerosDocumentos({ idCuenta: cliente?.paquete?.cuenta?.Id_Cuenta, idPaquete: cliente?.paquete?.Id_Paquete }))
  }, [dispatch, cliente?.paquete?.cuenta?.Id_Cuenta, cliente?.paquete?.Id_Paquete])

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="center">#</TableCell>
            <TableCell align="center">Nombre</TableCell>
            <TableCell align="center">Fecha de nacimiento</TableCell>
            <TableCell align="center">Pasaporte</TableCell>
            <TableCell align="center">Fecha de vencimiento</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {pasajeros.map((row, index) => (
            <TableRow key={index + 1}>
              <TableCell align="center" component="th" scope="row">
                {index + 1}
              </TableCell>
              <TableCell align="center">{`${row.Nombre} ${row.ApellidoPaterno} ${row.ApellidoMaterno}`}</TableCell>
              <TableCell align="center">
                {
                  FormatoFechaIso({ date: row?.FechaNacimiento, formato: "dd MMMM yyyy" })
                }
              </TableCell>
              <TableCell align="center">
                {
                  (row?.documento) ? row?.documento?.NumeroPasaporte : "No aplica"
                }
              </TableCell>
              <TableCell align="center">
                {
                  (row?.documento) ? FormatoFechaIso({ date: row?.documento?.FechaVencimiento, formato: "dd MMMM yyyy" }) : "No aplica"
                }
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
export default TablaDocumentos